const scroll = () => {
  $("a[href^='#']:not([data-fslightbox])").on(
    "click",
    function (e) {
      e.preventDefault();
      $("html,body")
        .stop()
        .animate(
          {
            scrollTop: $(`#${this.href.split("#").pop()}`).offset().top,
          },
          700
        );
    }
  );
}

export default scroll;